var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"model-area"}},[_c('a-modal',{attrs:{"ok-text":"确认","cancel-text":"取消"},on:{"ok":_vm.hideModal},model:{value:(_vm.visible),callback:function ($$v) {_vm.visible=$$v},expression:"visible"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }